import React from 'react';

import AsyncImage from '@components/asyncImage/AsyncImage';
import { useAppSelector } from '@core/hooks/appHooks';
import { selectVendor } from '@core/store/appSlice/appSlice';
import {
  faBroccoli,
  faCarrot,
  faSteak,
} from '@fortawesome/pro-light-svg-icons';
import {
  faCircleInfo,
  faFaceAwesome,
  faHeart,
  faPhone,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBasketShopping,
  faChevronLeft,
  faLocationDot,
  faMagnifyingGlass,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DemmiFS } from '@subhanhabib/demmilib';

interface Props {
  productImages: string[];
  vendorAddress: string;
}

const DisplayShop: React.FC<Props> = ({ productImages, vendorAddress }) => {
  const CSSBlock = 'display-shop';
  const vendor = useAppSelector(selectVendor);

  return (
    <div className={`${CSSBlock}__app`}>
      <div className={`${CSSBlock}__header`}>
        <div className={`${CSSBlock}__title`}>
          <span className={`${CSSBlock}__icon`}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </span>
          Field & Flowers
          <span className={`${CSSBlock}__icon`}>
            <FontAwesomeIcon icon={faBasketShopping} />
          </span>
        </div>
        <div className={`${CSSBlock}__buttons-row`}>
          <div className={`${CSSBlock}__buttons-row-button`}>
            <span className={`${CSSBlock}__icon`}>
              <FontAwesomeIcon icon={faFaceAwesome} />
            </span>
          </div>
          <div className={`${CSSBlock}__buttons-row-button`}>
            <span className={`${CSSBlock}__icon`}>
              <FontAwesomeIcon icon={faPhone} />
            </span>
          </div>
          <div className={`${CSSBlock}__buttons-row-button`}>
            <span className={`${CSSBlock}__icon`}>
              <FontAwesomeIcon icon={faCircleInfo} />
            </span>
          </div>
          <div className={`${CSSBlock}__buttons-row-button`}>
            <span className={`${CSSBlock}__icon`}>
              <FontAwesomeIcon icon={faHeart} />
            </span>
          </div>
        </div>
        <div className={`${CSSBlock}__location`}>
          <div className={`${CSSBlock}__location-top`}>
            <span className={`${CSSBlock}__icon`}>
              <FontAwesomeIcon icon={faLocationDot} />
            </span>
            6.17 KM AWAY
          </div>
          <div className={`${CSSBlock}__location-address`}>{vendorAddress}</div>
        </div>
        <div className={`${CSSBlock}__search`}>
          <span className={`${CSSBlock}__icon`}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </span>
          Search for something
        </div>
      </div>
      <div className={`${CSSBlock}__categories`}>
        <div className={`${CSSBlock}__category`}>
          <span className={`${CSSBlock}__icon`}>
            <FontAwesomeIcon icon={faBroccoli} />
          </span>
          Category Name
        </div>
        <div className={`${CSSBlock}__category`}>
          <span className={`${CSSBlock}__icon`}>
            <FontAwesomeIcon icon={faCarrot} />
          </span>
          Category Name
        </div>
        <div className={`${CSSBlock}__category`}>
          <span className={`${CSSBlock}__icon`}>
            <FontAwesomeIcon icon={faSteak} />
          </span>
          Category Name
        </div>
      </div>
      <div className={`${CSSBlock}__section-title`}>Product Highlights</div>
      <div className={`${CSSBlock}__product-list`}>
        <div className={`${CSSBlock}__product`}>
          <div className={`${CSSBlock}__product-image`}>
            {productImages.length > 0 && (
              <AsyncImage
                src={
                  productImages[
                    Math.floor(Math.random() * productImages.length)
                  ]
                }
                localLoadingIndicator
              />
            )}
          </div>
          <div className={`${CSSBlock}__product-name`}>Product Name</div>
          <div className={`${CSSBlock}__product-price`}>
            <span>
              {DemmiFS.CurrencyHelper.getCurrencySymbolFromCountryCode(
                vendor?.address?.countryCode ?? '',
              )}
            </span>
            0.30<span>/ each</span>
          </div>
          <div className={`${CSSBlock}__product-variant`}>4 variants</div>
        </div>
        <div className={`${CSSBlock}__product`}>
          <div className={`${CSSBlock}__product-image`}>
            {productImages.length > 0 && (
              <AsyncImage
                src={
                  productImages[
                    Math.floor(Math.random() * productImages.length)
                  ]
                }
                localLoadingIndicator
              />
            )}
          </div>
          <div className={`${CSSBlock}__product-name`}>Product Name</div>
          <div className={`${CSSBlock}__product-price`}>
            <span>
              {DemmiFS.CurrencyHelper.getCurrencySymbolFromCountryCode(
                vendor?.address?.countryCode ?? '',
              )}
            </span>
            9.99<span>/ each</span>
          </div>
          <div className={`${CSSBlock}__product-variant`}>2 variants</div>
        </div>
        <div className={`${CSSBlock}__product`}>
          <div className={`${CSSBlock}__product-image`}>
            {productImages.length > 0 && (
              <AsyncImage
                src={
                  productImages[
                    Math.floor(Math.random() * productImages.length)
                  ]
                }
                localLoadingIndicator
              />
            )}
          </div>
          <div className={`${CSSBlock}__product-name`}>Product Name</div>
          <div className={`${CSSBlock}__product-price`}>
            <span>
              {DemmiFS.CurrencyHelper.getCurrencySymbolFromCountryCode(
                vendor?.address?.countryCode ?? '',
              )}
            </span>
            9.99<span>/ each</span>
          </div>
          <div className={`${CSSBlock}__product-variant`}>
            85 grams per item
          </div>
        </div>
      </div>
      <div className={`${CSSBlock}__section-title`}>Reviews</div>
      <div className={`${CSSBlock}__reviews-list`}>
        <div className={`${CSSBlock}__review`}>
          <div className={`${CSSBlock}__review-title`}>Review Title</div>
          <div className={`${CSSBlock}__review-date`}>01/01/2023</div>
          <div className={`${CSSBlock}__review-rating`}>
            <span className={`${CSSBlock}__review-rating-icon`}>
              <FontAwesomeIcon icon={faFaceAwesome} />
            </span>
          </div>
          <div className={`${CSSBlock}__review-description`}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris at
            dapibus nulla. Integer cursus justo quam, ac sagittis orci fringilla
            vitae onsectetur adipiscing elit. Mauris at dapibus
          </div>
        </div>
      </div>
      {/* <div className={`${CSSBlock}__button`}>View All Reviews</div> */}
    </div>
  );
};

export default DisplayShop;
